// extracted by css-extract-rspack-plugin
export default {"card":"V7Wc8","rows":"e9olu","iconCircle":"oL5km","text":"jFepn","link":"YTGH3"};